// AgencyJobsTab's reads and its rows' status writes (finance-real, the user 2026-10-22): every client's jobs. The open
// job's drawer is the page's (AgencyLineJobDrawer). While New job is open, the clients it can go on (the user 2026-10-24):
// the agency's own, when Setup names one, and the clients the Invoices tab's New invoice offers.
import type { UseMutationResult, UseQueryResult } from "@tanstack/react-query";
import type { ClientChoice } from "../../clientPage/LineJobForms";
import { useOwnClient } from "../../hooks/useLedger";
import { useAgencyJobs, useSetJobStatus } from "../../hooks/useLineJobs";
import { useAgencyInvoiceList } from "../../hooks/useTeamInvoices";
import type { AgencyJobsResponse, LineJob, LineJobStatusInput } from "../../types";

export interface AgencyJobsTabModel {
  jobsQuery: UseQueryResult<AgencyJobsResponse>;
  setStatus: UseMutationResult<LineJob, Error, { jobId: string; input: LineJobStatusInput }>;
  /** New job's clients, the own client first; undefined until both reads answer, or while New job is closed. */
  newJobClients: ClientChoice[] | undefined;
}

export function useAgencyJobsTab(creating = false): AgencyJobsTabModel {
  const own = useOwnClient(creating).data;
  const list = useAgencyInvoiceList(creating).data;
  const newJobClients =
    creating && own && list
      ? [
          ...(own.clientId ? [{ id: own.clientId, name: own.clientName ?? "", ownClient: true }] : []),
          ...list.clients.filter((c) => c.id !== own.clientId).map((c) => ({ ...c, ownClient: false })),
        ]
      : undefined;
  return { jobsQuery: useAgencyJobs(), setStatus: useSetJobStatus(), newJobClients };
}
